<template>
  <div class="page-view container-view" v-loading="saveLoading">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title> 货车通行证预约登记 (当前申请年份{{ canApplyDate }}) </e6-title>
    </section>
    <!-- title end -->
    <el-form :model="auditParams" label-width="160px" ref="aduitForm">
      <section :class="['content-top', { 'no-top-info': stepIndex != 0 }]">
        <div class="step">
          <template>
            <div
              :class="[
                'step-item',
                `stem-item-${i}`,
                { active: stepIndex === i }
              ]"
              v-for="(v, i) in stepList"
              :key="i"
              @click="changeStep(i)"
            >
              <span class="dot">{{ i + 1 }}</span>
              {{ v }}
            </div>
          </template>
        </div>
        <div class="info" v-show="stepIndex == 0">
          <p>
            <span>企业名称：{{ auditParams.companyName }}</span>
            <el-button type="text" class="ml20" @click="downloadFiles"
              >附件批量下载</el-button
            >
          </p>
          <p>
            <!-- 审核 -->
            <el-row
              class="audit-operate"
              v-if="auditOperateShowFun(auditParams.firstStatus)"
            >
              <el-col :span="3" v-if="pageType != 'detail'">
                <el-switch
                  v-model="auditParams.firstStatus"
                  :active-text="
                    auditParams.firstStatus == 20 ? '审核不通过' : '审核通过'
                  "
                  active-color="#87D068"
                  inactive-color="#FF6600"
                  :active-value="30"
                  :inactive-value="20"
                  @change="
                    checked =>
                      changeAuditStatus(checked, 'firstRejectionRemark')
                  "
                >
                </el-switch>
              </el-col>
              <el-col class="audit-operate-title" :span="2" v-else>
                <span>审核不通过</span>
              </el-col>
              <el-col :span="16" v-if="auditParams.firstStatus == 20">
                <el-form-item
                  prop="firstRejectionRemark"
                  class="no-border"
                  :rules="formRule"
                >
                  <el-input
                    :disabled="pageType == 'detail'"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    v-model="auditParams.firstRejectionRemark"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </p>
          <p class="title">《广州市冷链配送企业运力保障预约登记表》</p>
          <p class="tips">
            <i class="e6-icon-tips_line"></i>
            表单填写完成后，请下载并打印文件，加盖企业公章后再次上传电子扫描件
          </p>
          <div>
            <upload-pdf
              type="check"
              v-model="auditParams.imageListMap[0]"
            ></upload-pdf>
          </div>
        </div>
      </section>
      <!-- content -->
      <section :class="['content-section', { 'no-top-info': stepIndex != 0 }]">
        <div class="table-area">
          <!-- <el-form :model="form" label-width="150px" ref="form" :key="refresh"> -->
          <div class="page page-1" ref="page1">
            <el-form-item label="企业类型" class="h42">
              <el-checkbox-group
                v-model="auditParams.firstTypeList"
                :disabled="true"
              >
                <el-checkbox :label="0">冷链物流企业</el-checkbox>
                <el-checkbox :label="1">商贸流通企业</el-checkbox>
                <el-checkbox :label="2">冷链产品生产企业</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item class="info-title bg-gray">
              <div>1.企业基本情况</div>
            </el-form-item>
            <el-form-item label="1.1企业名称">
              <div>{{ auditParams.companyName }}</div>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="1.2.1注册地址">
                  <div>{{ auditParams.registeredAddress }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="1.2.2邮编" class="no-border-left">
                  {{ auditParams.registeredPostCode }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="1.3.1通讯地址">
                  <div>{{ auditParams.mailingAddress }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="1.3.2邮编" class="no-border-left">
                  <div>{{ auditParams.mailingPostCode }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="1.4.1企业网址">
                  <div>{{ auditParams.companyUrl }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="1.4.2传真" class="no-border-left">
                  <div>{{ auditParams.fax }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="1.5.1法人代表">
                  <div>{{ auditParams.legalPerson }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="1.5.2联系电话" class="no-border-left">
                  <div>{{ auditParams.legalPhone }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="1.5.3身份证号" class="no-border-left">
                  <div>{{ auditParams.legalCard }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="1.6.1联系人">
                  <div>{{ auditParams.contact }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="1.6.2联系电话" class="no-border-left">
                  <div>{{ auditParams.contactPhone }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="1.6.3电子邮箱" class="no-border-left">
                  <div>{{ auditParams.contactEmail }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="1.7.1注册资金(万元)">
                  <div>{{ auditParams.registeredMoney }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="1.7.2其中外资(万元)"
                  class="no-border-left"
                >
                  <div>{{ auditParams.registeredMoneyOut }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="1.8企业性质">
                  <el-radio-group
                    v-model="auditParams.companyNature"
                    :disabled="true"
                  >
                    <el-radio
                      v-for="(v, i) in companyNatureList"
                      :key="i"
                      :label="v.id"
                    >
                      {{ v.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="其他请注明具体性质" class="no-border-left">
                  <div>{{ auditParams.companyNatureRemark }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="1.9企业形式">
                  <el-radio-group
                    v-model="auditParams.companyForm"
                    :disabled="true"
                  >
                    <el-radio
                      v-for="(v, i) in companyFormList"
                      :key="i"
                      :label="v.id"
                    >
                      {{ v.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="其他请注明具体形式" class="no-border-left">
                  <div>{{ auditParams.companyFormRemark }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 企业经营情况 -->
            <el-form-item class="info-title bg-gray">
              <div>2.企业经营情况</div>
            </el-form-item>
            <el-row>
              <el-col :span="16">
                <el-form-item label="2.1从事业务" class="h42">
                  <el-checkbox-group
                    v-model="auditParams.engageBusinessList"
                    :disabled="true"
                  >
                    <el-checkbox
                      v-for="(v, i) in engageBusinessList"
                      :key="i"
                      :label="v.id"
                    >
                      {{ v.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="其他请注明具体业务" class="no-border-left">
                  <div>{{ auditParams.engageBusinessRemark }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="2.2.1共同配送业务">
                  <el-radio-group
                    v-model="auditParams.jointDelivery"
                    :disabled="true"
                  >
                    <el-radio
                      v-for="(v, i) in jointDeliveryList"
                      :key="i"
                      :label="v.id"
                    >
                      {{ v.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="若已开展请填写年业务总量(吨)"
                  label-width="225px"
                >
                  <div>{{ auditParams.jointDeliveryTotal }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="merge-line no-border-left">
                  <p>2.3经营状况</p>
                </div>
                <el-form-item class="no-border-left">
                  <div>2.3.1资产总额（万元）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.3.2经营收入（万元）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.3.3增值税及所得税（万元）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.3.4经营时间</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="`${auditParams.assetsTotalTitle}年度`"
                  class="no-border-left"
                >
                  <div>{{ auditParams.assetsTotal }}</div>
                </el-form-item>
                <el-form-item
                  :label="`${auditParams.assureTotalTitle}年度`"
                  class="no-border-left"
                >
                  <div>{{ auditParams.assureTotal }}</div>
                </el-form-item>
                <el-form-item
                  :label="`${auditParams.vatAndIncomeTaxTitle}年度`"
                  class="no-border-left"
                >
                  <div>{{ auditParams.vatAndIncomeTax }}</div>
                </el-form-item>
                <el-form-item label="开始时间（年份）" class="no-border-left">
                  <div>{{ auditParams.assureDateStart }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="`${auditParams.assetsTotalTwoTitle}年度`"
                  class="no-border-left"
                >
                  <div>{{ auditParams.assetsTotalTwo }}</div>
                </el-form-item>
                <el-form-item
                  :label="`${auditParams.assureTotalTwoTitle}年度`"
                  class="no-border-left"
                >
                  <div>{{ auditParams.assureTotalTwo }}</div>
                </el-form-item>
                <el-form-item
                  :label="`${auditParams.vatAndIncomeTaxTwoTitle}年度`"
                  class="no-border-left"
                >
                  <div>{{ auditParams.vatAndIncomeTaxTwo }}</div>
                </el-form-item>
                <el-form-item label="至（年份）" class="no-border-left">
                  <div>{{ auditParams.assureDateEnd }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="merge-line h328">
                  <p>2.4服务能力</p>
                </div>
                <el-form-item class="no-border-left">
                  <div>2.4.1服务网点数（个）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.2客户数量（个）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.3日均配送量（吨）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.4车辆月平均里程（公里）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.5获得行业荣誉、资质或认证</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.6参与大型活动项目及服务内容</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.7获得政府嘉奖及表彰</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.8主要负责人担任社会职务或社团职务情况</div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item class="position-left no-border-left">
                  <div>{{ auditParams.serviceNum }}</div>
                </el-form-item>
                <el-form-item class="position-left no-border-left">
                  <div>{{ auditParams.clientNum }}</div>
                </el-form-item>
                <el-form-item class="position-left no-border-left">
                  <div>{{ auditParams.averageDailyDelivery }}</div>
                </el-form-item>
                <el-form-item class="position-left no-border-left">
                  <div>{{ auditParams.vehicleMileage }}</div>
                </el-form-item>
                <el-form-item class="position-left no-border-left">
                  <div>{{ auditParams.industryHonor }}</div>
                </el-form-item>
                <el-form-item class="position-left no-border-left">
                  <div>{{ auditParams.activeProject }}</div>
                </el-form-item>
                <el-form-item class="position-left no-border-left">
                  <div>{{ auditParams.governmentCite }}</div>
                </el-form-item>
                <el-form-item class="position-left no-border-left">
                  <div>{{ auditParams.personCharge }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="merge-line">
                  <p>2.5设备设施-冷藏车</p>
                </div>
                <el-form-item>
                  <div>2.5.1数量（辆）</div>
                </el-form-item>
                <el-form-item>
                  <div>2.5.2新能源车辆占比（%）</div>
                </el-form-item>
                <el-form-item class="h80">
                  <div>
                    2.5.3符合《道路机动车辆生产企业及产品公告》规定（%）
                  </div>
                </el-form-item>
                <el-form-item>
                  <div>2.5.4冷配车统一标识</div>
                </el-form-item>
                <el-form-item>
                  <div>2.5.5车辆监控系统</div>
                </el-form-item>
                <el-form-item>
                  <div>2.5.6物流信息系统服务商</div>
                </el-form-item>
                <el-form-item>
                  <div>2.5.7上一年度获得冷配证</div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item class="inline-row no-border-left">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="自用（辆）" class="no-border-left">
                        <div>{{ auditParams.coldVehicleSelfNum }}</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="合作（辆）">
                        <div>
                          {{ auditParams.coldCooperationVehicleNum }}
                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item class="position-left no-border-left">
                  <div>{{ auditParams.energyVehicle }}</div>
                </el-form-item>
                <el-form-item class="position-left no-border-left h80">
                  <div>{{ auditParams.conformRoadRegulation }}</div>
                </el-form-item>
                <el-form-item class="inline-row no-border-left">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item class="no-border-left">
                        <el-radio-group
                          v-model="auditParams.coldCarMark"
                          :disabled="true"
                        >
                          <el-radio :label="0">没有</el-radio>
                          <el-radio :label="1">有（请填写车辆数）</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="若有请填写车辆数">
                        <div>{{ auditParams.coldCarNum }}</div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item class="info-title no-border-left">
                  <el-radio-group
                    v-model="auditParams.vehicleMonitor"
                    :disabled="true"
                  >
                    <el-radio :label="1">100%</el-radio>
                    <el-radio :label="2">70%以上</el-radio>
                    <el-radio :label="0">无</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item class="position-left no-border-left">
                  <div>{{ auditParams.logisticsInfoSystemServe }}</div>
                </el-form-item>
                <el-form-item class="inline-row no-border-left">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item class="no-border-left">
                        <el-radio-group
                          v-model="auditParams.lastYearColdCard"
                          :disabled="true"
                        >
                          <el-radio :label="0">没有</el-radio>
                          <el-radio :label="1">有（请填写个数）</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="若有请填写个数">
                        <div>{{ auditParams.lastYearColdCardNum }}</div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="merge-line">
                  <p>2.6设备设施-冷库</p>
                </div>
                <el-form-item label="">
                  <div>2.6.1是否有冷库</div>
                </el-form-item>
                <el-form-item label="">
                  <div>2.6.2自建</div>
                </el-form-item>
                <el-form-item label="">
                  <div>2.6.3租赁</div>
                </el-form-item>
                <el-form-item label="">
                  <div>2.6.4仓储信息系统服务商</div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  class="info-title no-border-left"
                  prop="coldStorageHaveOne"
                >
                  <el-radio-group
                    :disabled="true"
                    v-model="auditParams.coldStorageHaveOne"
                  >
                    <el-radio :label="0"
                      >没有（没有则不用填写下方冷库相关内容）</el-radio
                    >
                    <el-radio :label="1"
                      >有（有则必须填写下方冷库相关内容）</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item class="inline-row no-border-left">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        label="容量（立方米）"
                        class="no-border-left"
                      >
                        <div>{{ auditParams.coldStorageSelfVolume }}</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="建设时间（年月日）">
                        <div>{{ auditParams.coldStorageSelfDate }}</div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item class="inline-row no-border-left">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        label="容量（立方米）"
                        class="no-border-left"
                      >
                        <div>{{ auditParams.coldStorageLeaseVolume }}</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="协议租赁期（年份）">
                        <div>{{ auditParams.coldStorageLeaseDate }}</div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item class="info-title no-border-left">
                  <el-input v-model="auditParams.storageInfoServe"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="merge-line border-bottom">
                  <p>2.7安全及保障</p>
                </div>
                <el-form-item>
                  <div>2.7.1管理制度</div>
                </el-form-item>
                <el-form-item>
                  <div>2.7.2安全教育</div>
                </el-form-item>
                <el-form-item>
                  <div>2.7.3运营保障</div>
                </el-form-item>
                <el-form-item class="border-bottom">
                  <div>2.7.4应急预案</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item class="info-title fwNormal no-border-left">
                  <div>有健全的财务、车辆、证照、安全等方面的管理制度</div>
                </el-form-item>
                <el-form-item class="info-title fwNormal no-border-left">
                  <div>
                    有相关安全生产方面的学习、培训、检查、考核等方面的记录
                  </div>
                </el-form-item>
                <el-form-item class="info-title fwNormal no-border-left">
                  <div>有针对运营方面的培训和改善记录等</div>
                </el-form-item>
                <el-form-item
                  class="info-title fwNormal no-border-left border-bottom"
                >
                  <div>有完备的应急预案、演练、记录等</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item class="info-title no-border-left">
                  <el-radio-group
                    v-model="auditParams.manageSystem"
                    :disabled="true"
                  >
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                    <el-radio :label="2">待完善</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item class="info-title no-border-left">
                  <el-radio-group
                    v-model="auditParams.safeEducation"
                    :disabled="true"
                  >
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                    <el-radio :label="2">待完善</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item class="info-title no-border-left">
                  <el-radio-group
                    v-model="auditParams.assureGuarantee"
                    :disabled="true"
                  >
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                    <el-radio :label="2">待完善</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item class="info-title no-border-left border-bottom">
                  <el-radio-group
                    v-model="auditParams.emergencyPlan"
                    :disabled="true"
                  >
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                    <el-radio :label="2">待完善</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 第二页数据 -->
          <div class="page page-2" ref="page2">
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                1.企业证件信息上传
                <span class="upload-tips-title"
                  >（只能上传jpg/png文件,且不超过2M）</span
                >
              </p>
              <div class="upload-img">
                <template v-for="(v, index) in pictureSourceList">
                  <el-form-item :key="index" label-width="0">
                    <div :key="index" class="img-content">
                      <p class="upload-title">{{ v.title }}</p>
                      <div class="imgCss">
                        <upload-img
                          height="150px"
                          width="180px"
                          type="check"
                          :cardTitle="v.cardTitle"
                          v-model="v.pictureUrl"
                        ></upload-img>
                      </div>
                      <p v-if="index == 1 || index == 2" class="upload-tips">
                        如没有此证请上传说明文件
                      </p>
                    </div>
                  </el-form-item>
                </template>
              </div>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    auditParams.companyBaseInfoMap[10].companyBaseInfoStatus
                  )
                "
              >
                <el-col :span="3" v-if="pageType != 'detail'">
                  <el-switch
                    v-model="
                      auditParams.companyBaseInfoMap[10].companyBaseInfoStatus
                    "
                    :active-text="
                      auditParams.companyBaseInfoMap[10]
                        .companyBaseInfoStatus == 20
                        ? '审核不通过'
                        : '审核通过'
                    "
                    active-color="#87D068"
                    inactive-color="#FF6600"
                    :active-value="30"
                    :inactive-value="20"
                    @change="checked => changeAuditStatus(checked, '', 10)"
                  >
                  </el-switch>
                </el-col>
                <el-col class="audit-operate-title" :span="2" v-else>
                  <span>审核不通过</span>
                </el-col>
                <el-col
                  :span="16"
                  v-if="
                    auditParams.companyBaseInfoMap[10].companyBaseInfoStatus ==
                      20
                  "
                >
                  <el-form-item
                    :prop="`companyBaseInfoMap[10].rejectionRemark`"
                    :rules="formRule"
                  >
                    <el-input
                      :disabled="pageType == 'detail'"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入驳回原因"
                      v-model="
                        auditParams.companyBaseInfoMap[10].rejectionRemark
                      "
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">2.企业简介、征信记录上传</p>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">2.1 企业简介</p>
                <el-form-item label-width="30px">
                  <div>
                    <upload-pdf
                      v-model="auditParams.imageListMap[20]"
                      type="check"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">2.2 企业征信记录</p>
                <el-form-item label-width="30px">
                  <div>
                    <upload-pdf
                      type="check"
                      v-model="auditParams.imageListMap[21]"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    auditParams.companyBaseInfoMap[20].companyBaseInfoStatus
                  )
                "
              >
                <el-col :span="3" v-if="pageType != 'detail'">
                  <el-switch
                    v-model="
                      auditParams.companyBaseInfoMap[20].companyBaseInfoStatus
                    "
                    :active-text="
                      auditParams.companyBaseInfoMap[20]
                        .companyBaseInfoStatus == 20
                        ? '审核不通过'
                        : '审核通过'
                    "
                    active-color="#87D068"
                    inactive-color="#FF6600"
                    :active-value="30"
                    :inactive-value="20"
                    @change="checked => changeAuditStatus(checked, '', 20)"
                  >
                  </el-switch>
                </el-col>
                <el-col class="audit-operate-title" :span="2" v-else>
                  <span>审核不通过</span>
                </el-col>
                <el-col
                  :span="16"
                  v-if="
                    auditParams.companyBaseInfoMap[20].companyBaseInfoStatus ==
                      20
                  "
                >
                  <el-form-item
                    :prop="`companyBaseInfoMap[20].rejectionRemark`"
                    :rules="formRule"
                  >
                    <el-input
                      :disabled="pageType == 'detail'"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入驳回原因"
                      v-model="
                        auditParams.companyBaseInfoMap[20].rejectionRemark
                      "
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                3.企业与主要客户签订的服务合同、服务网点及路线清单
              </p>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">
                  3.1 与主要客户签订的服务合同（若无，请上传说明文件）
                </p>
                <el-form-item label-width="30px">
                  <div>
                    <upload-pdf
                      type="check"
                      v-model="auditParams.imageListMap[31]"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">3.2 服务网点及线路清单</p>
                <el-form-item label-width="30px">
                  <div>
                    <upload-pdf
                      acceptType=".xls,.xlsx"
                      type="check"
                      v-model="auditParams.imageListMap[32]"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    auditParams.companyBaseInfoMap[30].companyBaseInfoStatus
                  )
                "
              >
                <el-col :span="4" v-if="pageType != 'detail'">
                  <el-switch
                    v-model="
                      auditParams.companyBaseInfoMap[30].companyBaseInfoStatus
                    "
                    :active-text="
                      auditParams.companyBaseInfoMap[30]
                        .companyBaseInfoStatus == 20
                        ? '审核不通过'
                        : '审核通过'
                    "
                    active-color="#87D068"
                    inactive-color="#FF6600"
                    :active-value="30"
                    :inactive-value="20"
                    @change="checked => changeAuditStatus(checked, '', 30)"
                  >
                  </el-switch>
                </el-col>
                <el-col class="audit-operate-title" :span="2" v-else>
                  <span>审核不通过</span>
                </el-col>
                <el-col
                  :span="16"
                  v-if="
                    auditParams.companyBaseInfoMap[30].companyBaseInfoStatus ==
                      20
                  "
                >
                  <el-form-item
                    :prop="`companyBaseInfoMap[30].rejectionRemark`"
                    :rules="formRule"
                  >
                    <el-input
                      :disabled="pageType == 'detail'"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入驳回原因"
                      v-model="
                        auditParams.companyBaseInfoMap[30].rejectionRemark
                      "
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                4.经注册会计事务所审计的本企业上年度财务审计报告
              </p>
              <el-form-item label-width="30px">
                <div>
                  <upload-pdf
                    type="check"
                    v-model="auditParams.imageListMap[40]"
                  ></upload-pdf>
                </div>
              </el-form-item>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    auditParams.companyBaseInfoMap[40].companyBaseInfoStatus
                  )
                "
              >
                <el-col :span="3" v-if="pageType != 'detail'">
                  <el-switch
                    v-model="
                      auditParams.companyBaseInfoMap[40].companyBaseInfoStatus
                    "
                    :active-text="
                      auditParams.companyBaseInfoMap[40]
                        .companyBaseInfoStatus == 20
                        ? '审核不通过'
                        : '审核通过'
                    "
                    active-color="#87D068"
                    inactive-color="#FF6600"
                    :active-value="30"
                    :inactive-value="20"
                    @change="checked => changeAuditStatus(checked, '', 40)"
                  >
                  </el-switch>
                </el-col>
                <el-col class="audit-operate-title" :span="2" v-else>
                  <span>审核不通过</span>
                </el-col>
                <el-col
                  :span="16"
                  v-if="
                    auditParams.companyBaseInfoMap[40].companyBaseInfoStatus ==
                      20
                  "
                >
                  <el-form-item
                    :prop="`companyBaseInfoMap[40].rejectionRemark`"
                    :rules="formRule"
                  >
                    <el-input
                      :disabled="pageType == 'detail'"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入驳回原因"
                      v-model="
                        auditParams.companyBaseInfoMap[40].rejectionRemark
                      "
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">5.企业上年度纳税证明</p>
              <el-form-item label-width="30px">
                <div>
                  <upload-pdf
                    type="check"
                    v-model="auditParams.imageListMap[50]"
                  ></upload-pdf>
                </div>
              </el-form-item>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    auditParams.companyBaseInfoMap[50].companyBaseInfoStatus
                  )
                "
              >
                <el-col :span="3" v-if="pageType != 'detail'">
                  <el-switch
                    v-model="
                      auditParams.companyBaseInfoMap[50].companyBaseInfoStatus
                    "
                    :active-text="
                      auditParams.companyBaseInfoMap[50]
                        .companyBaseInfoStatus == 20
                        ? '审核不通过'
                        : '审核通过'
                    "
                    active-color="#87D068"
                    inactive-color="#FF6600"
                    :active-value="30"
                    :inactive-value="20"
                    @change="checked => changeAuditStatus(checked, '', 50)"
                  >
                  </el-switch>
                </el-col>
                <el-col class="audit-operate-title" :span="2" v-else>
                  <span>审核不通过</span>
                </el-col>
                <el-col
                  :span="16"
                  v-if="
                    auditParams.companyBaseInfoMap[50].companyBaseInfoStatus ==
                      20
                  "
                >
                  <el-form-item
                    :prop="`companyBaseInfoMap[50].rejectionRemark`"
                    :rules="formRule"
                  >
                    <el-input
                      :disabled="pageType == 'detail'"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入驳回原因"
                      v-model="
                        auditParams.companyBaseInfoMap[50].rejectionRemark
                      "
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                6.企业管理制度清单及制度内容，包括车辆管理制度、车辆证照管理制度、安全生产管理制度、应急服务措施、服务操作规程等
                <el-form-item label-width="30px">
                  <div>
                    <upload-pdf
                      type="check"
                      v-model="auditParams.imageListMap[60]"
                    ></upload-pdf>
                  </div>
                </el-form-item>
                <!-- 审核 -->
                <el-row
                  class="audit-operate"
                  v-if="
                    auditOperateShowFun(
                      auditParams.companyBaseInfoMap[60].companyBaseInfoStatus
                    )
                  "
                >
                  <el-col :span="4" v-if="pageType != 'detail'">
                    <el-switch
                      v-model="
                        auditParams.companyBaseInfoMap[60].companyBaseInfoStatus
                      "
                      :active-text="
                        auditParams.companyBaseInfoMap[60]
                          .companyBaseInfoStatus == 20
                          ? '审核不通过'
                          : '审核通过'
                      "
                      active-color="#87D068"
                      inactive-color="#FF6600"
                      :active-value="30"
                      :inactive-value="20"
                      @change="checked => changeAuditStatus(checked, '', 60)"
                    >
                    </el-switch>
                  </el-col>
                  <el-col class="audit-operate-title" :span="2" v-else>
                    <span>审核不通过</span>
                  </el-col>
                  <el-col
                    :span="16"
                    v-if="
                      auditParams.companyBaseInfoMap[60]
                        .companyBaseInfoStatus == 20
                    "
                  >
                    <el-form-item
                      :prop="`companyBaseInfoMap[60].rejectionRemark`"
                      :rules="formRule"
                    >
                      <el-input
                        :disabled="pageType == 'detail'"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入驳回原因"
                        v-model="
                          auditParams.companyBaseInfoMap[60].rejectionRemark
                        "
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </p>
              <div></div>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                7.上传《{{
                  canApplyDate
                }}年度冷藏车通行预约登记冷链物流类企业申请表》
              </p>
              <el-form-item label-width="30px">
                <div>
                  <upload-pdf
                    type="check"
                    v-model="auditParams.imageListMap[70]"
                  ></upload-pdf>
                </div>
              </el-form-item>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    auditParams.companyBaseInfoMap[70].companyBaseInfoStatus
                  )
                "
              >
                <el-col :span="3" v-if="pageType != 'detail'">
                  <el-switch
                    v-model="
                      auditParams.companyBaseInfoMap[70].companyBaseInfoStatus
                    "
                    :active-text="
                      auditParams.companyBaseInfoMap[70]
                        .companyBaseInfoStatus == 20
                        ? '审核不通过'
                        : '审核通过'
                    "
                    active-color="#87D068"
                    inactive-color="#FF6600"
                    :active-value="30"
                    :inactive-value="20"
                    @change="checked => changeAuditStatus(checked, '', 70)"
                  >
                  </el-switch>
                </el-col>
                <el-col class="audit-operate-title" :span="2" v-else>
                  <span>审核不通过</span>
                </el-col>
                <el-col
                  :span="16"
                  v-if="
                    auditParams.companyBaseInfoMap[70].companyBaseInfoStatus ==
                      20
                  "
                >
                  <el-form-item
                    :prop="`companyBaseInfoMap[70].rejectionRemark`"
                    :rules="formRule"
                  >
                    <el-input
                      :disabled="pageType == 'detail'"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入驳回原因"
                      v-model="
                        auditParams.companyBaseInfoMap[70].rejectionRemark
                      "
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                8.主要获奖证书等荣誉证明（非必填，最多可上传5个附件）
              </p>
              <el-form-item label-width="30px">
                <div class="upload-wrapper">
                  <!-- <span class="tips">仅支持PDF文档</span> -->
                  <el-upload
                    :class="['upload-demo', 'check-file']"
                    action="/app/file/upload/file"
                    multiple
                    :file-list="uploadFileList"
                  >
                    <el-button size="mini">
                      <i class="e6-icon-upload_fill"></i>点击上传</el-button
                    >
                  </el-upload>
                  <div :class="['preview', 'check-file-preview']">
                    <template v-for="(v, i) in uploadFileList">
                      <div :key="i">
                        <el-button
                          type="text"
                          @click="preView(v.url)"
                          v-if="
                            v.name.substring(
                              v.name.length - 4,
                              v.name.length
                            ) == '.pdf'
                          "
                          >点击预览</el-button
                        >
                      </div>
                    </template>
                  </div>
                </div>
              </el-form-item>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    auditParams.companyBaseInfoMap[80].companyBaseInfoStatus
                  )
                "
              >
                <el-col :span="3" v-if="pageType != 'detail'">
                  <el-switch
                    v-model="
                      auditParams.companyBaseInfoMap[80].companyBaseInfoStatus
                    "
                    :active-text="
                      auditParams.companyBaseInfoMap[80]
                        .companyBaseInfoStatus == 20
                        ? '审核不通过'
                        : '审核通过'
                    "
                    active-color="#87D068"
                    inactive-color="#FF6600"
                    :active-value="30"
                    :inactive-value="20"
                    @change="checked => changeAuditStatus(checked, '', 80)"
                  >
                  </el-switch>
                </el-col>
                <el-col class="audit-operate-title" :span="2" v-else>
                  <span>审核不通过</span>
                </el-col>
                <el-col
                  :span="16"
                  v-if="
                    auditParams.companyBaseInfoMap[80].companyBaseInfoStatus ==
                      20
                  "
                >
                  <el-form-item
                    :prop="`companyBaseInfoMap[80].rejectionRemark`"
                    :rules="formRule"
                  >
                    <el-input
                      :disabled="pageType == 'detail'"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入驳回原因"
                      v-model="
                        auditParams.companyBaseInfoMap[80].rejectionRemark
                      "
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">9.企业承诺书</p>
              <el-form-item label-width="30px">
                <div>
                  <upload-pdf
                    type="check"
                    v-model="auditParams.imageListMap[90]"
                  ></upload-pdf>
                </div>
              </el-form-item>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    auditParams.companyBaseInfoMap[90].companyBaseInfoStatus
                  )
                "
              >
                <el-col :span="3" v-if="pageType != 'detail'">
                  <el-switch
                    v-model="
                      auditParams.companyBaseInfoMap[90].companyBaseInfoStatus
                    "
                    :active-text="
                      auditParams.companyBaseInfoMap[90]
                        .companyBaseInfoStatus == 20
                        ? '审核不通过'
                        : '审核通过'
                    "
                    active-color="#87D068"
                    inactive-color="#FF6600"
                    :active-value="30"
                    :inactive-value="20"
                    @change="checked => changeAuditStatus(checked, '', 90)"
                  >
                  </el-switch>
                </el-col>
                <el-col class="audit-operate-title" :span="2" v-else>
                  <span>审核不通过</span>
                </el-col>
                <el-col
                  :span="16"
                  v-if="
                    auditParams.companyBaseInfoMap[90].companyBaseInfoStatus ==
                      20
                  "
                >
                  <el-form-item
                    :prop="`companyBaseInfoMap[90].rejectionRemark`"
                    :rules="formRule"
                  >
                    <el-input
                      :disabled="pageType == 'detail'"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入驳回原因"
                      v-model="
                        auditParams.companyBaseInfoMap[90].rejectionRemark
                      "
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- 第三页数据 -->
          <div class="page page-3" ref="page3">
            <div class="info-wrapper">
              <p class="info-wrapper_title">1.冷库信息</p>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">1.1 是否有冷库</p>
                <el-form-item label-width="30px">
                  <el-radio-group
                    :disabled="true"
                    v-model="auditParams.coldStorageHave"
                  >
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">没有</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div
                class="info-wrapper-sub"
                v-if="auditParams.coldStorageHave == 1"
              >
                <p class="info-wrapper-sub_title">1.2 冷库类型</p>
                <el-form-item label-width="30px">
                  <el-checkbox-group
                    v-model="auditParams.coldStorageTypeList"
                    :disabled="true"
                  >
                    <el-checkbox :label="10">自建</el-checkbox>
                    <el-checkbox :label="20">租赁</el-checkbox>x>
                  </el-checkbox-group>
                </el-form-item>
              </div>
              <div
                class="info-wrapper-sub"
                v-if="auditParams.coldStorageTypeList.includes(10)"
              >
                <p class="info-wrapper-sub_title">1.3 自建冷库信息</p>
                <div class="pl30">
                  <span class="c666">
                    已选择冷库：{{
                      auditParams.coldStorageSelfList
                        .map(v => v.coldStorageName)
                        .join("、")
                    }}
                  </span>
                  <!---冷库信息表格--->
                  <p v-if="auditParams.coldStorageSelfList.length">
                    已选仓库信息预览：（{{
                      auditParams.coldStorageSelfList.length
                    }}个)
                  </p>
                  <el-table
                    v-if="auditParams.coldStorageSelfList.length"
                    :data="auditParams.coldStorageSelfList"
                    border
                    style="width: 100%"
                  >
                    <el-table-column
                      label="冷库名称"
                      min-width="120"
                      align="left"
                    >
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.coldStorageName }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="冷库类型" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.coldStorageTypeName }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="存储物品(可输入修改)"
                      min-width="120"
                    >
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>
                            {{
                              scope.row.coldStorageGoodName ||
                                scope.row.coldStorageGoodText
                            }}
                          </div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="联系人" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.coldContactMan }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="电话" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.coldContactPhone }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div
                class="info-wrapper-sub"
                v-if="auditParams.coldStorageTypeList.includes(20)"
              >
                <p class="info-wrapper-sub_title">1.4 租赁冷库合同</p>
                <el-form-item label-width="30px">
                  <div>
                    <upload-pdf
                      type="check"
                      v-model="auditParams.imageListMap[113]"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="auditOperateShowFun(auditParams.coldStorageStatus)"
              >
                <el-col :span="3" v-if="pageType != 'detail'">
                  <el-switch
                    v-model="auditParams.coldStorageStatus"
                    :active-text="
                      auditParams.coldStorageStatus == 20
                        ? '审核不通过'
                        : '审核通过'
                    "
                    active-color="#87D068"
                    inactive-color="#FF6600"
                    :active-value="30"
                    :inactive-value="20"
                    @change="
                      checked =>
                        changeAuditStatus(checked, 'coldStorageRejectionRemark')
                    "
                  >
                  </el-switch>
                </el-col>
                <el-col class="audit-operate-title" :span="2" v-else>
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="16" v-if="auditParams.coldStorageStatus == 20">
                  <el-form-item
                    prop="coldStorageRejectionRemark"
                    :rules="formRule"
                  >
                    <el-input
                      :disabled="pageType == 'detail'"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入内容"
                      v-model="auditParams.coldStorageRejectionRemark"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">2.冷藏车信息</p>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">2.1 冷藏车信息</p>
                <div class="pl30">
                  <span class="c666">
                    已选择车辆：{{
                      auditParams.coldVehicleDetailList
                        .map(v => v.vehicleNum)
                        .join("、")
                    }}
                  </span>
                  <!-- 车辆信息 -->
                  <p v-if="auditParams.coldVehicleDetailList.length">
                    已选车辆信息预览：（{{
                      auditParams.coldVehicleDetailList.length
                    }}个)
                  </p>
                  <el-table
                    v-if="auditParams.coldVehicleDetailList.length"
                    :data="auditParams.coldVehicleDetailList"
                    border
                    style="width: 100%"
                  >
                    <el-table-column label="车牌号" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.vehicleNum }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="上一年度行驶里程" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.runMileage }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="报废时间" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.scrapDate }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="接入省冷链平台时间" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>
                            {{
                              scope.row.joinDate
                                ? scope.row.joinDate
                                : scope.row.createdTime
                            }}
                          </div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="上年度违章处罚情况" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.lastIllegalPunish }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="曾获城配证时间" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.lastGetProof }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="上一次获得冷配证类型"
                      min-width="140"
                    >
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.lastColdDeliveryCardStr }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="上一次获得冷配证编号"
                      min-width="120"
                    >
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.lastColdDeliveryNo }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">
                  2.2
                  请提供机动车登记证书及《机动车行驶证》的主、副页的正、反面，或冷藏车购置合同及发票
                </p>
                <el-form-item label-width="30px">
                  <div>
                    <upload-pdf
                      type="check"
                      v-model="auditParams.imageListMap[222]"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="auditOperateShowFun(auditParams.coldVehicleStatus)"
              >
                <el-col :span="3" v-if="pageType != 'detail'">
                  <el-switch
                    v-model="auditParams.coldVehicleStatus"
                    :active-text="
                      auditParams.coldVehicleStatus == 20
                        ? '审核不通过'
                        : '审核通过'
                    "
                    active-color="#87D068"
                    inactive-color="#FF6600"
                    :active-value="30"
                    :inactive-value="20"
                    @change="
                      checked =>
                        changeAuditStatus(checked, 'coldVehicleRejectionRemark')
                    "
                  >
                  </el-switch>
                </el-col>
                <el-col class="audit-operate-title" :span="2" v-else>
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="16" v-if="auditParams.coldVehicleStatus == 20">
                  <el-form-item
                    prop="coldVehicleRejectionRemark"
                    :rules="formRule"
                  >
                    <el-input
                      :disabled="pageType == 'detail'"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入内容"
                      v-model="auditParams.coldVehicleRejectionRemark"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- </el-form> -->
        </div>
      </section>
    </el-form>
    <!-- content end -->
    <section class="btn-group">
      <el-button @click="goBack()">返回</el-button>
      <el-button @click="aduitData(0)" v-if="pageType != 'detail'"
        >保存并返回列表页</el-button
      >
      <el-button @click="changeStep(stepIndex - 1)" v-if="stepIndex != 0"
        >上一页</el-button
      >
      <el-button @click="changeStep(stepIndex + 1)" v-if="stepIndex != 2">
        下一页
      </el-button>
      <el-button
        v-if="pageType != 'detail' && !showPassBtn"
        type="primary"
        @click="aduitData(20)"
      >
        驳回
      </el-button>
      <el-button
        v-if="pageType != 'detail' && showPassBtn"
        type="primary"
        @click="aduitData(30)"
      >
        通过
      </el-button>
    </section>
    <!-- 检验信息提示框 -->
    <el-dialog
      class="valid-dialog"
      title="未填写驳货原因信息展示"
      :visible.sync="validInfoDialog"
      width="700px"
    >
      <div class="valid-item" v-if="firstPageValidList.length">
        <p>第一页以下审核项未填写驳货原因：</p>
        <span v-for="(v, i) in firstPageValidList" :key="i">
          {{ i + 1 }}. {{ v.name }}
        </span>
        <br />
      </div>
      <div class="valid-item" v-if="sencodPageValidList.length">
        <p>第二页以下审核项未填写驳货原因：</p>
        <span v-for="(v, i) in sencodPageValidList" :key="i">
          {{ i + 1 }}. {{ v.name }}
        </span>
        <br />
      </div>
      <div class="valid-item" v-if="thirdPageValidList.length">
        <p>第三页以下审核项未填写驳货原因：</p>
        <span v-for="(v, i) in thirdPageValidList" :key="i">
          {{ i + 1 }}. {{ v.name }}
        </span>
        <br />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="validInfoDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import uploadImg from "@/components/uploadImg";
import uploadPdf from "@/components/uploadPdf";
import { cloneDeep } from "lodash";
import { aduitColNameAndPageIndex } from "../js/index";
// components
// import pdfAll from "@/components/pdfAll/index.vue";
// api
import { saveBookingAudit } from "@/api/businessApplication";

const emptyPictureSourceList = [
  // 从业人员照片
  {
    title: "营业执照",
    cardTitle: "点击上传",
    pictureType: "photo10",
    pictureUrl: ""
  },
  {
    title: "道路运输许可证",
    cardTitle: "点击上传",
    pictureType: "photo11",
    pictureUrl: ""
  },
  {
    title: "食品生产许可证",
    cardTitle: "点击上传",
    pictureType: "photo12",
    pictureUrl: ""
  },
  {
    title: "其他(非必填)",
    cardTitle: "点击上传",
    pictureType: "photo13",
    pictureUrl: ""
  }
];
export default {
  // name: "applicationContent",
  components: { uploadImg, uploadPdf },
  props: {
    pageType: {
      type: String,
      default: "detail"
    }
  },
  data() {
    return {
      canApplyDate: "",
      saveLoading: false,
      refresh: new Date().getTime(),
      bookingStatus: "", // 当前申请状态
      // 步骤条
      stepIndex: 0,
      // 企业性质
      stepList: ["企业运力保障登记表", "企业基础信息", "冷库、冷藏车信息"],
      url: "", // 上传地址
      fileList: [
        {
          type: 0,
          url: "",
          name: "",
          titleNo: "1-1-"
        }
      ],
      fileSrc: "",
      showPassBtn: false, // 是否显示通过按钮
      // 表单校验数据
      firstPageValidList: [],
      sencodPageValidList: [],
      thirdPageValidList: [],
      validInfoDialog: false,
      uploadFileList: [], // 附件数据
      // 审核参数
      auditParams: {
        bookingId: "",
        bookingRejectionRemark: "", // 整体表单驳回原因
        bookingStatus: 0, // 整体表单审核状态
        coldStorageRejectionRemark: "", // 第三页冷库驳回原因
        coldStorageStatus: 30, // 第三页冷库审核状态
        coldVehicleRejectionRemark: "", // 第三页冷藏车驳回原因
        coldVehicleStatus: 30, // 第三页冷藏车审核状态
        // 第二页状态
        companyBaseInfoMap: {
          10: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          20: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          30: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          40: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          50: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          60: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          70: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          80: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          90: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          }
        },
        firstRejectionRemark: "", // 第一页审核驳回原因
        firstStatus: 30, // 第一页审状态,
        firstTypeList: [], // 企业类型
        companyName: "",
        registeredAddress: "", // 注册地址
        registeredPostCode: "", // 注册地址邮编
        mailingAddress: "", // 通讯地址
        mailingPostCode: "", // 通讯地址邮编
        companyUrl: "", // 企业网址
        fax: "", //传真
        legalPerson: "", //法人代表
        legalPhone: "", //联系电话
        legalCard: "", // 身份证号
        contact: "",
        contactPhone: "",
        contactEmail: "",
        registeredMoney: "", // 注册资金
        registeredMoneyOut: "", // 其中外资
        companyNature: "", // 企业性质
        companyNatureRemark: "", //其他企业性质
        companyForm: "", // 企业形式
        companyFormRemark: "", // 其他企业形式
        coldStorageHaveOne: "",
        engageBusinessList: [], // 从事业务
        engageBusinessRemark: "",
        jointDelivery: "", //共同配送业务
        jointDeliveryTotal: "",
        assetsTotalTitle: moment()
          .subtract(2, "year")
          .format("YYYY"), //资产总额第一年标题
        assetsTotal: "", // 资产总额第一年
        assetsTotalTwoTitle: moment()
          .subtract(1, "year")
          .format("YYYY"), //资产总额第二年标题
        assetsTotalTwo: "", // 资产总额第二年
        assureTotalTitle: moment()
          .subtract(2, "year")
          .format("YYYY"), //经营收入第一年标题
        assureTotal: "", // 经营收入第一年
        assureTotalTwoTitle: moment()
          .subtract(1, "year")
          .format("YYYY"), //经营收入第二年标题
        assureTotalTwo: "", // 经营收入第二年
        vatAndIncomeTaxTitle: moment()
          .subtract(2, "year")
          .format("YYYY"), //增值税及所得税第一年标题
        vatAndIncomeTax: "", // 增值税及所得税第一年
        vatAndIncomeTaxTwoTitle: moment()
          .subtract(1, "year")
          .format("YYYY"), //增值税及所得税第二年标题
        vatAndIncomeTaxTwo: "", // 增值税及所得税第二年
        assureDateStart: "", // 经营开始时间
        assureDateEnd: "", // 经营结束时间
        serviceNum: "", //服务网点数（个）
        clientNum: "", //客户数量（个）
        averageDailyDelivery: "", // 日均配送量
        vehicleMileage: "", // 车辆月平均里程
        industryHonor: "", // 获得行业荣誉、资质或认证
        activeProject: "", // 参与大型活动项目及服务内容
        governmentCite: "", // 获得政府嘉奖及表彰
        personCharge: "", // 主要负责人担任社会职务或社团职务情况
        coldVehicleSelfNum: "", // 自用
        coldCooperationVehicleNum: "", // 合作
        energyVehicle: "", //新能源车辆占比
        conformRoadRegulation: "", //符合《道路机动车辆生产
        coldCarMark: "", //冷配车统一标识
        coldCarNum: "", // 冷配车
        vehicleMonitor: "", // 车辆监控系统
        logisticsInfoSystemServe: "", // 物流信息系统服务商
        lastYearColdCard: "", // 上一年度获得冷配证
        lastYearColdCardNum: "",
        coldStorageSelfVolume: "", // 自建容量
        coldStorageSelfDate: "", // 自建时间
        coldStorageLeaseVolume: "", // 租赁容量
        coldStorageLeaseDate: "", // 协议租赁时间
        storageInfoServe: "", // 仓储信息系统服务商
        manageSystem: "", // 有健全的财务、车辆、证照、安全等方面的管理制度
        safeEducation: "", //  有相关安全生产方面
        assureGuarantee: "", // 运营方面
        emergencyPlan: "", // 应急预案
        // 第二页
        pageTwofileList: {
          photo10: "",
          photo11: "",
          photo12: "",
          photo13: ""
        },
        // 0:冷链配送企业运力保障预约登记表、10:营业执照、11:道路运输许可证、12:食品生产许可证、13:其他;
        // 20:企业简介、21:企业征信记录;
        // 31:与主要客户签订的服务合同、32:服务网点及线路清单;
        // 40:经注册会计事务所审计的本企业上年度财务审计报告;\n50:企业上年度纳税证明;
        // 60:企业管理制度清单及制度内容,包括...;7
        //70:保障应急预案、包括应急演练....;
        //80:主要获奖证书等荣誉证明;
        //113:租赁冷库合同;
        //222:冷藏车租赁协议，冷藏车购置合同和发票及《机动车行驶证》的主、副页的正、反面和绿色环保标志

        imageListMap: {
          0: [
            {
              type: 0,
              url: "",
              name: "",
              titleNo: "1-1-"
            }
          ],
          10: [
            {
              type: 10,
              url: "",
              name: "营业执照",
              titleNo: "2-1-"
            }
          ],
          11: [
            {
              type: 11,
              url: "",
              name: "道路运输许可证",
              titleNo: "2-2-"
            }
          ],
          12: [
            {
              type: 12,
              url: "",
              name: "食品生产许可证",
              titleNo: "2-3-"
            }
          ],
          13: [
            {
              type: 13,
              url: "",
              name: "其他",
              titleNo: "2-4-"
            }
          ],
          20: [
            {
              type: 20,
              url: "",
              name: "",
              titleNo: "2-5-"
            }
          ],
          21: [
            {
              type: 21,
              url: "",
              name: "",
              titleNo: "2-6-"
            }
          ],
          31: [
            {
              type: 31,
              url: "",
              name: "",
              titleNo: "2-7-"
            }
          ],
          32: [
            {
              type: 32,
              url: "",
              name: "",
              titleNo: "2-8-"
            }
          ],
          40: [
            {
              type: 40,
              url: "",
              name: "",
              titleNo: "2-9-"
            }
          ],
          50: [
            {
              type: 50,
              url: "",
              name: "",
              titleNo: "2-10-"
            }
          ],
          60: [
            {
              type: 60,
              url: "",
              name: "",
              titleNo: "2-11-"
            }
          ],
          70: [
            {
              type: 70,
              url: "",
              name: "",
              titleNo: "2-12-"
            }
          ],
          80: [
            {
              type: 80,
              url: "",
              name: "",
              titleNo: "2-13-"
            }
          ],
          90: [
            {
              type: 90,
              url: "",
              name: "",
              titleNo: "2-14-"
            }
          ],
          113: [
            {
              type: 113,
              url: "",
              name: "",
              titleNo: "3-1-"
            }
          ],
          222: [
            {
              type: 222,
              url: "",
              name: "",
              titleNo: "3-2-"
            }
          ]
        },
        // 第三页
        coldStorageHave: "",
        coldStorageTypeList: [], // 冷库类型
        coldStorageSelfList: [],
        coldVehicleDetailList: []
      },
      formRule: [
        {
          required: true,
          message: "不能为空",
          trigger: "blur"
        }
      ],
      // 企业性质
      companyNatureList: [
        {
          id: 1,
          label: "国有企业"
        },
        {
          id: 2,
          label: "集体所有制企业"
        },
        {
          id: 3,
          label: "外商独资"
        },
        {
          id: 4,
          label: "联营企业"
        },
        {
          id: 5,
          label: "三资企业"
        },
        {
          id: 6,
          label: "私营企业"
        },
        {
          id: 0,
          label: "其他(注明具体性质)"
        }
      ],
      // 企业形式
      companyFormList: [
        {
          id: 1,
          label: "有限责任制公司"
        },
        {
          id: 2,
          label: "股份公司"
        },
        {
          id: 3,
          label: "有限公司"
        },
        {
          id: 0,
          label: "其他(注明具体形式)"
        }
      ],
      // 从事业务
      engageBusinessList: [
        {
          id: 1,
          label: "供应链管理"
        },
        {
          id: 2,
          label: "电子商务物流"
        },
        {
          id: 3,
          label: "民生保障服务"
        },
        {
          id: 4,
          label: "应急供应服务"
        },
        {
          id: 5,
          label: "特殊定温产品"
        },
        {
          id: 0,
          label: "其他(注明具体业务)"
        }
      ],
      jointDeliveryList: [
        {
          id: 0,
          label: "未开展"
        },
        {
          id: 1,
          label: "已开展（请填写年业务总量(吨)）"
        }
      ],
      //-----------------第二页数据-----------------------------
      pictureSourceList: JSON.parse(JSON.stringify(emptyPictureSourceList))
    };
  },
  created() {
    this.bookingStatus = this.$route.query.bookingStatus;
  },
  mounted() {},
  methods: {
    auditOperateShowFun(val) {
      // 草稿及审核中状态时，查看详情页，审核操作不展示
      if (
        this.pageType == "detail" &&
        (this.bookingStatus == 10 || this.bookingStatus == 0)
      ) {
        return false;
      }
      // 已驳回状态，查看详情页，驳回的小类进行展示，通过的不展示
      if (this.pageType == "detail" && this.bookingStatus == 20) {
        if (val == 20) {
          return true;
        } else {
          return false;
        }
      }
      if (this.pageType == "examine") {
        return true;
      }
    },
    // 编辑页面填充数据
    init(data) {
      this.canApplyDate = data.bookingDateStr;
      Object.assign(this.auditParams, data);
      this.pictureSourceList[0].pictureUrl = this.auditParams.imageListMap[10][0].url;
      this.pictureSourceList[1].pictureUrl = this.auditParams.imageListMap[11][0].url;
      this.pictureSourceList[2].pictureUrl = this.auditParams.imageListMap[12][0].url;
      this.pictureSourceList[3].pictureUrl = this.auditParams.imageListMap[13][0].url;
      this.fileList = [];
      this.fileList.push(this.auditParams.imageListMap[0][0]);
      this.uploadFileList = [];
      this.auditParams.imageListMap[80].forEach(v => {
        this.uploadFileList.push({
          url: v.url,
          name: v.name
        });
      });
      this.refresh = new Date().getTime();
      this.$nextTick(() => {
        this.caclFormHeight();
        this.setPassBtnStatus();
      });
    },
    // 切换步骤条
    changeStep(i) {
      this.stepIndex = i;
      if (i == 0) {
        this.$refs.page1.style.position = "relative";
        this.$refs.page1.style.left = "0%";
        this.$refs.page2.style.position = "absolute";
        this.$refs.page2.style.left = "100%";
        this.$refs.page3.style.position = "absolute";
        this.$refs.page3.style.left = "200%";
      }
      if (i == 1) {
        this.$refs.page1.style.position = "absolute";
        this.$refs.page1.style.left = "-100%";
        this.$refs.page2.style.position = "relative";
        this.$refs.page2.style.left = "0";
        this.$refs.page3.style.position = "absolute";
        this.$refs.page3.style.left = "100%";
      }
      if (i === 2) {
        this.$refs.page1.style.position = "absolute";
        this.$refs.page1.style.left = "-200%";
        this.$refs.page2.style.position = "absolute";
        this.$refs.page2.style.left = "-100%";
        this.$refs.page3.style.position = "relative";
        this.$refs.page3.style.left = "0%";
      }
    },
    // 动态计算文件高度
    caclFormHeight() {
      setTimeout(() => {
        // 动态计算文件高度
        let firstTopDom = document.getElementsByClassName("content-top");
        let firstDom = document.getElementsByClassName("content-section");
        let height = firstTopDom[0].clientHeight;
        firstDom[0].style.height = `calc(100%  - 10px - ${height}px - 45px)`;
      }, 1500);
    },
    // 切换审核状态
    changeAuditStatus(val, prop, type) {
      if (type) {
        this.auditParams.companyBaseInfoMap[type].rejectionRemark = "";
      } else {
        this.auditParams[prop] = "";
      }
      // 判断是否显示通过按钮
      this.setPassBtnStatus();
      this.$nextTick(() => {
        if (prop == "firstRejectionRemark") {
          this.caclFormHeight();
        }
      });
    },
    setPassBtnStatus() {
      let secondStatus = true;
      for (let i in this.auditParams.companyBaseInfoMap) {
        if (
          this.auditParams.companyBaseInfoMap[i].companyBaseInfoStatus == 20
        ) {
          secondStatus = false;
        }
      }
      if (
        this.auditParams.firstStatus == 30 &&
        secondStatus &&
        this.auditParams.coldStorageStatus == 30 &&
        this.auditParams.coldVehicleStatus == 30
      ) {
        this.showPassBtn = true;
      } else {
        this.showPassBtn = false;
      }
    },
    // PDF预览
    preView(val) {
      window.open(val);
    },
    // 审核数据
    aduitData(type) {
      if (type === 0) {
        this.saveAuditData(type);
      } else {
        this.$refs.aduitForm.validate((valid, obj) => {
          if (valid) {
            this.$confirm(
              `确定${
                type == 20 ? "驳回" : "通过"
              }审核，确定后表单状态不可退回？`,
              `${type == 20 ? "驳回" : "通过"}确认`,
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }
            )
              .then(() => {
                this.saveAuditData(type);
              })
              .catch(() => {});
          } else {
            this.firstPageValidList = [];
            this.sencodPageValidList = [];
            this.thirdPageValidList = [];
            let colValidArr = [];
            for (let v in obj) {
              if (aduitColNameAndPageIndex[v]) {
                colValidArr.push(aduitColNameAndPageIndex[v]);
              }
            }
            colValidArr.forEach(v => {
              if (v.pageIndex == 1) {
                this.firstPageValidList.push(v);
              }
              if (v.pageIndex == 2) {
                this.sencodPageValidList.push(v);
              }
              if (v.pageIndex == 3) {
                this.thirdPageValidList.push(v);
              }
            });
            this.validInfoDialog = true;
          }
        });
      }
    },
    // 保存审核数据
    async saveAuditData(type) {
      try {
        this.saveLoading = true;
        let params = cloneDeep(this.auditParams);
        type === 0
          ? (params.bookingStatus = "")
          : (params.bookingStatus = type);
        let res = await saveBookingAudit(params);
        if (res.code) {
          this.goBack();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.saveLoading = true;
      }
    },
    goBack() {
      this.$router.push({
        path: "/truckPassRegistration"
      });
    },
    // 批量下载附件
    downloadFiles() {
      try {
        let url = `/reserve/booking/download?bookingId=${this.auditParams.bookingId}`;
        document.location.href = url;
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.c666 {
  color: #606266;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.no-border-left {
  border-left: none !important;
}
.border-bottom {
  border-bottom: 1px solid #e6e6e6 !important;
}
.h80 {
  height: 80px;
}
.pl30 {
  padding-left: 30px;
}
// .h42 {
//   height: 42px !important;
// }
.ml20 {
  margin-left: 20px;
}
.no-border {
  border: none !important;
}

.content-top {
  margin: 0 20px;
  padding: 15px 20px 10px 20px;
  width: calc(100% - 40px);
  background: #fff;
  &.no-top-info {
    height: 60px !important;
  }
  .step {
    display: flex;
    width: calc(100% - 100px);
    padding-left: 100px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e6e6e6;
    .step-item {
      display: flex;
      width: calc(50% - 100px);
      color: #c0c4cc;
      cursor: pointer;
      font-size: 16px;
      .dot {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        top: -5px;
        margin-right: 5px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 2px solid #c0c4cc;
        color: #c0c4cc;
        background: #fff;
        color: #c0c4cc;
      }
      &.active {
        color: #303133;
        .dot {
          background: #2f4ef2;
          border: 2px solid #2f4ef2;
          color: #fff;
        }
      }
      &::after {
        display: inline-block;
        content: "";
        position: relative;
        top: 8px;
        width: calc(100% - 180px);
        height: 2px;
        background: #c0c4cc;
      }
      &.stem-item-1 {
        &::after {
          width: calc(100% - 130px);
        }
      }
      &.stem-item-2 {
        width: 200px;
        &::after {
          display: none;
        }
      }
    }
  }

  .info {
    margin-top: 15px;
    .title {
      margin: 0;
      color: #333;
      font-size: 16px;
      font-weight: bold;
    }
    .tips {
      color: #666;
      font-size: 12px;
    }
  }
}
.content-section {
  width: calc(100% - 40px);
  height: calc(100% - 54px - 10px - 100px - 45px);
  margin: 0 20px;
  padding: 20px;
  overflow: auto;
  background: #fff;
  &.no-top-info {
    height: calc(100% - 20px - 60px - 45px) !important;
  }
  .table-area {
    position: relative;
    width: 100%;
    min-width: 1200px;
    overflow-y: hidden;
    overflow-x: hidden;
    padding-bottom: 100px;
  }

  .fill-time {
    position: absolute;
    bottom: 50px;
    right: 20px;
    color: #606266;
  }
  .page {
    width: 100%;
  }
  .page-2 {
    position: absolute;
    left: 100%;
  }
  .page-3 {
    position: absolute;
    left: 200%;
    .sel-select {
      padding-left: 10px;
      margin: 10px 0 15px;
      width: 250px;
      max-width: auto;
      border: 1px solid #e6e6e6;
      border-radius: 6px;
    }
  }
  .page-2,
  .page-3 {
    .el-form-item--mini {
      &.el-form-item {
        border: none;
      }
    }
  }
  .info-wrapper {
    padding: 0px 20px;
    &_title {
      font-size: 16px;
      font-weight: bold;
    }
    &-sub {
      margin: 10px;
      &_title {
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
  .upload-tips-title {
    font-size: 14px;
    font-weight: normal;
    color: #606266;
  }
  .upload-img {
    display: flex;
    justify-content: space-around;
    text-align: center;
    .img-content {
      display: inline-block;
      margin-right: 20px;
      .upload-title {
        text-align: center;
        margin-top: 10px;
        color: #303133;
        font-size: 14px;
      }
      .imgCss {
        /deep/ .el-upload {
          width: auto !important;
        }
      }
      .upload-tips {
        margin: 0;
      }
    }
  }
  /deep/ .upload-pdf {
    .el-upload-list__item-status-label {
      display: none !important;
    }
  }
}
/deep/ .el-form {
  height: calc(100% - 54px);
  .el-form-item--mini {
    &.el-form-item {
      border: 1px solid #e6e6e6;
      border-bottom: none;
      margin-bottom: 0;

      &.info-title {
        .el-form-item__content {
          margin-left: 0 !important;
          padding-left: 5px !important;
          font-weight: bold;
        }
        &.bg-gray {
          div {
            background: #e6e6e6;
          }
        }
        &.fwNormal {
          .el-form-item__content {
            font-weight: normal !important;
          }
        }
      }
      &.position-left {
        .el-form-item__content {
          margin-left: 0 !important;
          padding-left: 5px !important;
        }
      }
      &.inline-row {
        > .el-form-item__content {
          padding-left: 0 !important;
          margin-left: 0 !important;
          .el-form-item {
            border: none;
            border-left: 1px solid #e6e6e6;
          }
        }
      }
    }
    .el-form-item__label {
      padding-left: 5px;
      text-align: left;
      min-height: 40px;
      line-height: 40px;
      background: #f6f6f6;
      font-size: 15px;
      border-right: 1px solid #e6e6e6;
    }
    .el-form-item__content {
      padding-left: 10px;
      min-height: 40px;
      line-height: 40px;
      color: #606266;
      font-size: 15px;
    }
  }
  .el-form-item__error {
    // top: 30% !important;
    left: auto;
    font-weight: normal !important;
    // right: 0px !important;
  }
  .el-input__inner {
    padding-left: 0 !important;
    border: none !important;
  }
  .merge-line {
    padding-left: 5px;
    width: 161px;
    height: 100%;
    position: absolute;
    color: #606266;
    background: #f6f6f6;
    border: 1px solid #e6e6e6;
    border-bottom: none;
    font-size: 15px;
    > p {
      margin: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .audit-operate {
    margin: 30px 0;
    .el-form-item__content {
      margin-left: 0 !important;
    }
    .audit-operate-title {
      text-align: right;
      color: #ff6600;
    }
    .el-switch__core {
      position: relative;
      left: 130px;
    }
    .el-switch__label {
      color: #ff6600;
      &.is-active {
        color: #87d068;
      }
    }
  }
}
/deep/ .el-checkbox__label {
  font-size: 15px !important;
}
/deep/ .el-radio__label {
  font-size: 15px !important;
}

.btn-group {
  z-index: 10;
  width: calc(100% - 40px);
  padding: 15px;
  text-align: center;
  position: absolute;
  left: 20px;
  bottom: 0px;
  background: #fff;
  box-shadow: 0 0 10px #eee;
}
// 验证信息弹框
/deep/ .valid-dialog {
  .el-dialog__body {
    max-height: 500px;
    overflow: auto;
  }
  .valid-item {
    margin-top: 30px;
    p {
      font-size: 16px;
      font-weight: bold;
    }
    span {
      display: block;
    }
  }
}
.upload-wrapper {
  position: relative;
  .tips {
    position: absolute;
    left: 127px;
    color: #999;
    font-size: 12px;
  }
  /deep/ .upload-demo {
    width: 50%;
    margin-top: 20px;
    &.check-file {
      margin-top: -40px;
      .el-button {
        display: none;
      }
      .el-upload-list__item {
        .el-icon-upload-success {
          display: none;
        }
        &:hover {
          background: transparent;
          .el-icon-close {
            display: none !important;
            opacity: 0 !important;
          }
        }
      }
    }
  }
  .preview {
    > div {
      line-height: 30px !important;
      min-height: 30px;
    }
    position: absolute;
    top: 49px;
    left: calc(50% - 90px);
    &.check-file-preview {
      top: 50px !important;
    }
  }
}
</style>
